import { ContentType, PublicationContentType } from '@app/entities/enums/multimedia/content-status-types.enum';

import { AbstractMultimediaItem } from './multimedia.abstract.model';
import { Publication } from './publication.model';

export abstract class Text extends AbstractMultimediaItem {
  abstract contentType: PublicationContentType.TEXT | ContentType.TEXT;
}

export class TextPublication extends Publication implements Text {
  contentType: PublicationContentType.TEXT = PublicationContentType.TEXT;
}
